/**
 * Created by liuxsen on 2017/3/25.
 */
/**
 * 格式化时间戳
 * @param str 时间戳
 */
let formatDate = function(str){
  let date = new Date(str);
  let Y = date.getFullYear();
  let M = date.getMonth() +1 <10? "0"+(date.getMonth()+1):date.getMonth();
  let D = date.getDate()<10 ? "0"+date.getDate():date.getDate();
  let h = date.getHours()<10 ? "0"+date.getHours():date.getHours();
  let m = date.getMinutes()<10 ? "0"+date.getMinutes():date.getMinutes;
  let s = date.getSeconds()<10? "0"+date.getSeconds():date.getSeconds();
  return Y+"-"+M+"-"+D;
};
export  default formatDate;



// WEBPACK FOOTER //
// ./src/uitil/dateFormat.js